import * as CatalogFetcher from './CatalogFetcher'
import * as CheckoutFetcher from './CheckoutFetcher'
import * as GatewayFetcher from './GatewayFetcher'
import * as CustomerFetcher from './CustomerFetcher'
import * as FunctionsFetcher from './FunctionsFetcher'
import * as GraphqlFetcher from './GraphqlFetcher'
import * as inStoreFileManagerFetcher from './inStoreFileManagerFetcher'
import * as MasterdataFetcher from './MasterdataFetcher'
import * as OMSFetcher from './OMSFetcher'
import * as DeviceFetcher from './DeviceFetcher'
import * as HookFetcher from './HookFetcher'
import * as HostFetcher from './HostFetcher'
import * as BrokerFetcher from './BrokerFetcher'
import * as PortalFetcher from './PortalFetcher'
import * as VtexDoFetcher from './VtexDoFetcher'

declare global {
  interface Window {
    handleBarcodeRead: ((barcode: string) => void) | null
  }
}

const fetchers = {
  CatalogFetcher,
  CheckoutFetcher,
  GatewayFetcher,
  CustomerFetcher,
  FunctionsFetcher,
  GraphqlFetcher,
  inStoreFileManagerFetcher,
  MasterdataFetcher,
  OMSFetcher,
  BrokerFetcher,
  DeviceFetcher,
  HookFetcher,
  HostFetcher,
  PortalFetcher,
  VtexDoFetcher,
}

if (typeof window !== 'undefined') {
  if (!window.vtexInstore) {
    window.vtexInstore = {
      fetchers,
      services: {},
    }
  } else {
    window.vtexInstore.fetchers = fetchers
  }
}
